import * as React from 'react';
import { Tag } from '../types';
export const Grid = ({ children, className, tag: Element = Tag.DIV, }) => {
    return React.createElement(Element, { className: `grid ${className}` }, children);
};
//# sourceMappingURL=component.js.map